import {
  KERNING_MAX,
  KERNING_MIN,
  KERNING_PRESET_VALUES,
  TRACKING_MAX,
  TRACKING_MIN,
  TRACKING_PRESET_VALUES,
  nearestKerningLabel,
  nearestTrackingLabel,
} from '@/components/app/panels/left-panel/type-panel/type-panel-presets'
import type { TextOnPathConfig } from '@/lib/shapes/types/text-on-path-config'

import type { TextOnPathConfigPatch } from '../types/control-props'
import type { SpacingMode } from '../types/spacing-mode'

/** What the Kerning|Tracking control's shared numeric field is bound to in `mode`. */
export function resolveSpacingFieldConfig(mode: SpacingMode, config: TextOnPathConfig) {
  const isKerning = mode === 'kerning'

  return {
    label: isKerning ? 'Kerning' : 'Tracking',
    value: isKerning ? config.kerning : config.tracking,
    min: isKerning ? KERNING_MIN : TRACKING_MIN,
    max: isKerning ? KERNING_MAX : TRACKING_MAX,
    presets: isKerning ? KERNING_PRESET_VALUES : TRACKING_PRESET_VALUES,
    presetLabel: isKerning ? nearestKerningLabel : nearestTrackingLabel,
    toPatch: (next: number): TextOnPathConfigPatch =>
      isKerning ? { kerning: next } : { tracking: next },
  }
}
